export enum LOGGER_TYPE {
  DAVINCI = 'davinci',
  PREMISE = 'premise',
  CONSOLE = 'console',
  AGENT_PC = 'agent pc'
}
